module.exports = "pegasus/assets/tech/update/101.png";